import { render, staticRenderFns } from "./UiShowcase.vue?vue&type=template&id=c69b657c&scoped=true"
import script from "./UiShowcase.vue?vue&type=script&lang=ts"
export * from "./UiShowcase.vue?vue&type=script&lang=ts"
import style0 from "./UiShowcase.vue?vue&type=style&index=0&id=c69b657c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69b657c",
  null
  
)

export default component.exports